@import '~style-sheet-helpers/core.less';
@import '../../../../constants/spacing.module.less';

@min-height-and-width: 225px;
@height-and-width: 264px;

.flex-space-between-align-center {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.addon-card {
  display: flex;
  flex-direction: column;
  flex: 1 1 @min-height-and-width;
  border: 1px solid var(--default--border-color--10);
  border-radius: 4px;
  max-height: @height-and-width;
  max-width: @height-and-width;
  background-color: var(--default--background-color-22);

  &.error {
    max-height: 274px;
  }

  &.available:hover {
    box-shadow: 0 4px 2px -2px hsl(var(--grey-1000-base), 16%);
    cursor: pointer;

    .add-button .details {
      background-color: var(--primary-button-pine--background-color);
      box-shadow: none;
    }

    .try-for-free-button {
      background: var(--pine-green-200);
      color: var(--pine-green);
      text-decoration: none;
    }
  }

  .banner-message {
    padding: @space-4;
    align-items: center;
    gap: @space-4;
    border-top: 1px solid var(--default--border-color--10);
    border-left: 1px solid var(--default--border-color--10);
    border-right: 1px solid var(--default--border-color--10);
    justify-content: space-between;
    border-top-right-radius: 1px solid var(--default--border-color--10);
    border-top-left-radius: 4px;

    &.error {
      border-bottom: 1px solid var(--Error-300, var(--red-300));
      background: var(--Error-200, var(--red-200));
    }

    button {
      width: auto;
    }

    div {
      gap: @space-4;
    }

    .close-button {
      cursor: pointer;
    }
  }
}

.addon-card-content {
  display: flex;
  flex-direction: column;
  flex: 1 1 @min-height-and-width;
}

.addon-header {
  min-height: 75px; // we need this to make the title (below icon) all align with each other and the icons are inconsistent in height
  .flex-space-between-align-center();
  padding: @space-16;

  .additional-details {
    width: 100%;
    text-align: right;
    margin-bottom: @space-4;
    color: var(--default--text-color--15);
    padding-top: @space-8;
    padding-right: @space-8;
  }

  .addon-image > img {
    width: unset;
  }
}

.addon-title {
  display: flex;
  justify-content: left;
  margin-bottom: @space-8;

  &.active-icon > img {
    width: @space-24;
    margin-left: @space-8;
  }
}

.addon-price {
  display: flex;
}

.addon-price .amount {
  margin: 0;
}

.addon-price .per-month {
  line-height: @space-24;
}

.addon-content {
  padding: @space-0 @space-16;
  text-align: start;

  .description {
    margin: 0 0 8px;
    line-height: @space-16;
  }
}

.add-addon-container {
  display: flex;
  text-align: center;
  flex-direction: column;
  justify-content: flex-end;
  flex: 1;
  padding: @space-0 @space-16 @space-16 @space-16;
}

.try-for-free-button {
  color: var(--default--text-color--22);
  border: 1px solid var(--primary-button-pine--background-color);
  border-radius: 4px;
  padding: @space-8 @space-12;

  &:hover {
    background: var(--pine-green-200);
    color: var(--default--text-color--22);
    text-decoration: none;
  }
}

.add-button {
  margin-top: @space-16;
  width: 100%;
  border-radius: 4px;
  &:hover {
    background-color: var(--default--background-color-22);
    box-shadow: none;
  }
  &.details {
    background-color: var(--primary-button-pine--background-color);
    color: var(--white);
    &:hover {
      background-color: var(--primary-button-pine--background-color);
      box-shadow: none;
    }
  }
}

.plan-details {
  font-style: italic;
  color: var(--default--text-color--15);
}

.return-rabbit-cta {
  display: flex;
  align-items: center;
  justify-content: center;

  > svg {
    margin-left: @space-8;
    height: @space-16;
    width: @space-16;
  }
}
